module.exports = __webpack_public_path__ + "assets/img/search.cf79e16b.png";